import _isEmpty from 'lodash/isEmpty';
import { withForm } from 'components/Form';
import messages from './EmailModal.messages';
import EmailModal from './EmailModal';

const syncValidator = values => {
  const errors = {};

  if (_isEmpty(values.message)) {
    errors.message = messages.messageRequired;
  }

  return errors;
};

export default withForm({
  name: 'EMAIL_MODAL_FORM',
  syncValidator,
})(EmailModal);
